import useDisposableModals from './model/hooks/useDisposableModals';
import { disposableModalsSegment } from './model/state-manager/disposableModalsSegment';

export default useDisposableModals;

export { disposableModalsSegment };
